/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PermissionRole {
    ADMIN = 'admin',
    USER_ADMIN = 'userAdmin',
    KYC_ADMIN = 'kycAdmin',
    EDITOR = 'editor',
    EXPORT_VIEWER = 'exportViewer',
    VIEWER = 'viewer',
}
